import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { Drawer, Descriptions, Divider, Row, Col, Tag, Alert, Collapse } from 'antd'
import { isMobile } from 'react-device-detect';
import { isValidDate, getActionColor } from '@/utils/helpers';
import AuditLogDiffTable from '@/routes/audit-logs/AuditLogDiffTable';
import AuditTimeline from '@/routes/audit-logs/AuditTimeline';

const { Panel } = Collapse;

class AuditLogDetail extends Component {
    constructor() {
        super();
        this.state = {
        };
    }

    handleCancel() {
        this.props.onCancel();
    }


    render() {
        var { visible, currentItem } = this.props;

        return (
            <>
                <Drawer
                    visible={visible}
                    title={`Lịch sử thay đổi: ${currentItem?.display_subject || ''}`}
                    onClose={() => this.handleCancel()}
                    maskClosable={false}
                    width={isMobile ? '100%' : '75%'}
                >
                    {visible ? (
                        <>
                            <Row gutter={16}>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Module">
                                            {currentItem?.display_module || '—'}
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Người thực hiện">
                                            {currentItem?.actor_name || currentItem?.user?.full_name || 'Hệ thống'}
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Hành động">
                                            <Tag color={getActionColor(currentItem?.action)}>{currentItem?.display_action}</Tag>
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Thời gian">
                                            {isValidDate(currentItem?.created_at, true)}
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Trường thay đổi">
                                            {currentItem?.display_changes?.map(item => item.label).join(', ') || 'Không có'}
                                        </Descriptions.Item>
                                    </Descriptions>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col xs={24} md={24}>
                                    {currentItem?.rolled_back_by && (
                                        <Alert
                                            message={`Bản ghi này đã được rollback bởi ${currentItem.rolled_back_by?.user?.full_name || '---'} vào lúc ${isValidDate(currentItem?.rolled_back_by.created_at, true)}`}
                                            type="warning"
                                            showIcon
                                            className='mt-2 mb-2'
                                        />
                                    )}

                                    {currentItem?.rollback_origin && (
                                        <Alert
                                            message={`Đây là bản ghi rollback từ log #${currentItem.rollback_of_log_id}`}
                                            type="warning"
                                            showIcon
                                            className='mt-2 mb-2'
                                        />
                                    )}
                                </Col>
                            </Row>
                            <h5 style={{ marginTop: 20 }}>So sánh thay đổi</h5>
                            <AuditLogDiffTable before={currentItem?.before} after={currentItem?.after} changes={currentItem?.display_changes || []} />
                            <Collapse bordered={false} style={{ marginTop: 16 }}>
                                <Panel header="Thông tin kỹ thuật" key="technical">
                                    <Descriptions size="small" column={1}>
                                        <Descriptions.Item label="Mã thao tác">{currentItem?.operation_id || '—'}</Descriptions.Item>
                                        <Descriptions.Item label="Địa chỉ IP">{currentItem?.ip_address || '—'}</Descriptions.Item>
                                        <Descriptions.Item label="Đường dẫn">{currentItem?.request_path || currentItem?.request_uri || '—'}</Descriptions.Item>
                                        <Descriptions.Item label="Phương thức">{currentItem?.request_method || currentItem?.method || '—'}</Descriptions.Item>
                                    </Descriptions>
                                </Panel>
                            </Collapse>
                            <h5 style={{ marginTop: 20 }}>Toàn bộ lịch sử của bản ghi</h5>
                            <AuditTimeline
                                subjectType={currentItem?.subject_type || currentItem?.model}
                                subjectId={currentItem?.subject_id || currentItem?.model_id}
                            />
                        </>
                    ) : null}
                </Drawer>
            </>
        )
    }
}
function mapStateToProps(state) {
    return {
    }
}

function mapDispatchToProps(dispatch) {
    return {

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'AuditLogDetail' })(AuditLogDetail));
